import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchUserBalance } from '../../../services/users';

export const getUserBalanceAsync = createAsyncThunk(
    'user/fetchBalance',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchUserBalance();
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch balance');
        }
    }
);

const userSlice = createSlice({
    name: 'userbal',
    initialState: {
        userBalance: null,
        loading: false,
        error: null
    },
    reducers: {
        setBalance(state, action) {
            state.userBalance = action.payload;
        },
        emptyBalance(state) {
            state.userBalance = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserBalanceAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUserBalanceAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.userBalance = action.payload.data;
                state.error = null;
            })
            .addCase(getUserBalanceAsync.rejected, (state, action) => {
                state.loading = false;
                state.userBalance = null;
                state.error = action.payload;
            });
    },
});

export const { setBalance, emptyBalance } = userSlice.actions;

export default userSlice.reducer;
